import {assert} from 'assert-ts';
import type {DataValue, LinkedLiterary} from 'schemaDefinition/types';
import {isLinkedLiterary} from './isLinkedLiterary';
import {isNullish} from './isNullish';

export const assertAsLinkedLiterary = (
  value: DataValue | null,
  context?: string,
): LinkedLiterary | undefined => {
  if (isLinkedLiterary(value) || isNullish(value)) {
    return value ?? undefined;
  }

  assert.soft(
    isLinkedLiterary(value),
    `assertAsLinkedLiterary: linked literary expected (${context ?? ''})`,
    {value},
  );

  return undefined;
};
